import { redMui } from "@ryde/theme";

/** Popup className — pairs with `MapVehicleTrackingPopupGlobalStyle`. */
export const MAP_VEHICLE_TRACKING_POPUP_CLASS = "map-vehicle-tracking-popup";

/** Vehicle tracking popup width (px); keep in sync with `MapTooltipStyled`. */
export const MAP_VEHICLE_TRACKING_POPUP_MIN_WIDTH_PX = 280;
export const MAP_VEHICLE_TRACKING_POPUP_MAX_WIDTH_PX = 320;

/** In-grid detour icon (`seedRidesMapCustomFields` imageOn). */
export const RIDE_IN_DETOUR_GRID_EMOJI = "🚨";

/** Detour vehicle flash + outward pulse ring (live map). */
export const MAP_VEHICLE_DETOUR_FLASH_COLOR = redMui._600;

/** Detour marker pulse period (incidents use 1.35s ease-out). */
export const MAP_VEHICLE_DETOUR_PULSE_DURATION_S = 1.65;
